import React from 'react';
import shopItems from '../../../config/shop';
import PurchaseItem from './PurchaseItem';

const Items = ({}) => {
    const cards = shopItems['items'].filter(item => item.type);
    const avatarsAndEmojis = shopItems['items'].filter(item => !item.type);
    console.log('items', cards, avatarsAndEmojis)
    return(
        <React.Fragment>
            { cards.map((card, index) => (
                <PurchaseItem
                    expiration={card.expiration}
                    price={card.price}
                    tab="items"
                    card={card.type}
                    key={index}
                />
            ))
            }
            { avatarsAndEmojis.map((item, index) => (
                <PurchaseItem
                  amount={item.name}
                  price={item.price}
                  label={item.label}
                  tab="items"
                  key={index}
              />
            ))

            }
        </React.Fragment>
    )
}
export default Items;